@if (options) {
	<ul>
		@if (options.length > 0) {
			@for (option of options; track option.code) {
				<li [attr.data-test]="'task-type-' + option.code" [class.fade-out]="!option.hasUserHandlePermission">
					<h2 (click)="selectTaskType.emit(option)">
						{{ option.name | language }}
					</h2>
					@if (!option.hasUserHandlePermission) {
						<i aria-hidden="true" class="fa fa-lock fa-lg"></i>
					}
				</li>
			}
		} @else {
			<empty-state icon="fa fa-tasks" message="{{ 'tasks.empty_unauthorized' | translate }}" />
		}
	</ul>
}
